export const convertToMegaByte = (num) => {
    try {
      return num * 1024 * 1024;
    } catch (e) {
      console.error('createMegaByte', e);
      return null;
    }
  }